import { cloneDeep as _cloneDeep, get as _get, set as _set } from '@lodash';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// eslint-disable-next-line import/prefer-default-export
export const redactAuthTokenAtPath = (obj: any, path: string) => {
    const objClone = _cloneDeep(obj);
    const originalStr = _get(objClone, path);
    const redactedStr = `****${originalStr.slice(originalStr.length - 4)}`;
    return _set(objClone, path, redactedStr);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/core/services/product/utils.ts